import { ButtonV2 } from '@cimplico/components';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/solid';
import { toastNotification } from '../../../../components/toast/Toast';
import { useBillingDashboard } from '../../../../queries/use-billing-dashboard';
import SectionLabel from '../../../../components/section-label/SectionLabel';
import SettingsContainer from '../../../../components/settings-container/SettingsContainer';

function Billing(): JSX.Element {
    const billingQuery = useBillingDashboard();
    async function getBillingUrl(): Promise<void> {
        try {
            const { data } = await billingQuery.refetch({ throwOnError: true });
            if (!data?.url) {
                throw new Error();
            }
            window.location.href = data.url;
        } catch (error) {
            toastNotification('error', 'Unable to get billing information!');
        }
    }

    return (
        <SettingsContainer isLastItem>
            <SectionLabel title="Billing" description="Update your payment method, card details and view your previous bills." />
            <div>
                <ButtonV2
                    size="sm"
                    label="Billing Dashboard"
                    onClick={getBillingUrl}
                    isLoading={billingQuery.isFetching}
                    isDisabled={billingQuery.isFetching}
                    leftIcon={<ArrowTopRightOnSquareIcon />}
                />
            </div>
        </SettingsContainer>
    );
}

export default Billing;
